<template>
  <definition
    :type="type"
    :content="content"
    :id="id"
    :fromPopup="fromPopup"
    :saveDefinition="saveDefinition"
    :saveDefinitionTo="saveDefinitionTo"
    :language="language"
    :visuals="visuals"
    :authorization="authorization"
    :apiparams="apiparams"
    :showloading="true"
    :menuName="name"
    :taskObject="taskObject"
    @definitionloading="definitionLoading"
    @definitionloaded="definitionLoaded"
    @definitionerror="definitionError"
    @refreshDefinition="refreshDefinition"
    @formDataActionCalled="formDataActionCalled"
    @closeDetail="closeDetail"
    @changeUrl="changeUrl"
    @popupClose="popupClose"
    @validatingFormError="validatingFormError"
    @callAction="callAction"
    @waitingProcessInit="waitingProcessInit"
    @modifyingAddForm="modifyingAddForm"
    @taskLink="taskLink"
    @removeUrlQueryParam="removeUrlQueryParam"
  />
</template>

<script>
import Vue from 'vue'
import Definition from 'vue-definition' // component definition in vue-definition node module
// import Definition from './definition' // component definition in this src directory
import languages from '@/language/languages'
import moment from 'moment'
import * as authTypes from '@/store/actions/auth'
import * as appTypes from '@/store/actions/app'
import { router } from '@/router'

export default {
  name: 'definition-loader',
  props: [
    'type',
    'content',
    'id',
    'fromPopup',
    'name',
    'saveDefinition',
    'saveDefinitionTo',
    'searcherDetailDefinition',
    'taskObject'
  ],
  data () {
    return {
      language: {},
      visuals: this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_VISUALS}`],
      authorization: localStorage.getItem('user-token'),
      apiparams: {
        multimediaurl: Vue.config.sherpaCrm.API_MULTIMEDIA_URL,
        mapsKey: Vue.config.sherpaCrm.API_GOOGLE_MAPS_KEY,
        translateKey: Vue.config.sherpaCrm.API_GOOGLE_TRANSLATE_KEY,
        translateUrl: Vue.config.sherpaCrm.API_GOOGLE_TRANSLATE_URL,
        htmlAbsolutePath: Vue.config.sherpaCrm.API_HTML_ABSOLUTE_PATH,
        tinymcetmdRootPath: Vue.config.sherpaCrm.API_TINYMCETMD_ROOT_PATH,
        tinymcetmdSkinPath: Vue.config.sherpaCrm.API_TINYMCETMD_SKIN_PATH,
        tinymcetmdLangPath: Vue.config.sherpaCrm.API_TINYMCETMD_LANG_PATH.replace('{{lang}}', this.$ml.current),
        assetsPath: Vue.config.sherpaCrm.APP_BASE_CONTEXT_PATH,
        newAssetsManager: Vue.config.sherpaCrm.APP_NEW_ASSETS_MANAGER
      },
      requestObjectBackup: null
    }
  },
  components: {
    Definition
  },
  beforeMount () {
    this.language = languages[this.$ml.current]
    this.type.domainEndpoint = Vue.config.sherpaCrm.API_SERVICES_URL + moment().valueOf()
    this.requestObjectBackup = JSON.stringify(this.content.requestObject)
  },
  methods: {
    taskLink (obj) {
      router.push(obj).catch(() => {})
    },
    removeUrlQueryParam () {
      this.$router.push(this.$route.path).catch(() => {})
    },
    definitionLoading () {
      this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, true)
    },
    waitingProcessInit () {
      this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, true)
    },
    modifyingAddForm () {
      this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, false)
    },
    definitionLoaded (content) {
      this.$emit('definitionLoaded', content)
      this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, false)
    },
    definitionError (error, resultError, container) {
      this.$store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_STATUS_ERROR}`, error)
    },
    refreshDefinition (newRequestObject) {
      var changed = (newRequestObject !== null && JSON.stringify(newRequestObject) !== this.requestObjectBackup)
      this.$emit('refreshDefinition', newRequestObject, changed)
    },
    callAction (type) {
      this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, true)
    },
    formDataActionCalled (stay) {
      this.$emit('formDataActionCalled', stay)
      this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, false)
    },
    closeDetail () {
      if (!this.searcherDetailDefinition) {
        this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_DETAIL_SHOWN}`, false)
      }
    },
    changeUrl (goTo) {
      this.$router.push(goTo).catch(() => {})
    },
    popupClose () {
      this.$emit('popupClose')
    },
    validatingFormError () {
      this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, false)
      this.$emit('validatingFormError')
    }
  },
  watch: {
    type (type) {
      type.domainEndpoint = Vue.config.sherpaCrm.API_SERVICES_URL + moment().valueOf()
    }
  }
}
</script>

<style lang="scss">
#sherpaCrmApp {
  .definition-title {
    span:first-of-type {
      display: block;
    }
  }
  .definitionObj {
    padding: 0 15px 0 3px;

    &.group {
      padding: 0 15px 0 3px;
    }

    &.gallery {
      padding: 0;
    }

    .label {
      font-weight: 600;
      font-family: Barlow;
    }

    &.conditional {
      padding: 0;
      min-height: 80px;
    }

    &.placeholder {
      label.label {
        color: transparent;
      }
    }
  }

  .definition-wrapper {
    padding: 2px 0 0;
    min-height: 47px;

    &.text {
      .w3-input {
        font-size: 14px;
        font-family: Barlow;
        height: 33px;
      }
    }
    &.conditional {
      padding: 0;
    }
  }
  #type_actions {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 62px;
    background-color: #342d38;
    z-index: 1000;

    .formErrors,
    .formSaved {
      font-family: Barlow;
      font-size: 16px;
      font-weight: 100;
    }

    button {
      margin-right: 20px;
      padding: 0 20px;
      height: 45px;
      border-radius: 8px;
      background-color: #ff7643;
      float: right;
      transition: all .2s ease-in;

      span {
        font-family: Capriola;
        font-size: 16px;
        font-weight: 400;
      }
    }

    .containerFormConfirmDelete {
      button {
        background-color: #fff;
      }

      .formConfirmDelete {
        display: none;
      }
    }
  }

  .noButtons {
    #type_actions {
      .messages {
        width: 100%;
      }
    }
  }

  .repeatable {
    .list-complete-item {
      position: relative;
      transition: all 0.4s ease-in;
      transform: none !important;
      padding: 0 0 15px !important;
      margin: 0 10px 10px 0;
      overflow-x: hidden;
      overflow-y: auto;

      &.modifying {
        z-index: 1000;
        width: initial;
        position: fixed;
        top: 53px;
        bottom: 66px;
        left: 5px;
        right: 5px;
        overflow-y: auto;
        background-color: #fff;
        margin: 0;
        border-radius: 3px;
        padding: 20px 30px 15px 30px !important;

        .buttons.modify {
          top: initial;
        }

        > .groupTasks {
          display: none;
        }

        .slot {
          padding-bottom: 0;
          padding-left: 0;
        }

      }
    }
    .repeatableGroupReadOnly {
      .tiny {
        max-height: 500px;
        overflow: hidden;
      }
    }
  }
  .repeatableButtons {
    button {
      span {
        font-family: Capriola;
      }
    }
  }
  .get-singlefile-company,
  .get-singlefile-professional,
  .get-singlefile-individual,
  .get-indicators-individual,
  .get-indicators-professional,
  .get-indicators-company {
    > #container_form_definition {
      padding: 0 0 10px 0 !important;
      left: 500px;
      bottom: 70px;
      top: 155px;
      right: 15px;
      width: auto;
      position: fixed;
      overflow-y: auto;

      .definition-title {
        display: none;
      }
    }
    .update-and-out {
      display: none;
    }
  }
  .get-cpg-form,
  .get-cpg-tlmkt,
  .get-cpg-postal {
    .repeatable {
      .list-complete-item {
        &.modifying {
          padding: 0 0 10px 380px !important;
        }
      }
    }

    .repeatableButtons {
      top: auto;
      position: fixed;
      bottom: 62px;
      left: 0;
      right: 0;
    }

    #appsur_cuestionarios_questblockdata > .definition-wrapper.open {
      & > .group-header {
        padding-left: 203px;
      }
      & > .group-elements {
        position: fixed;
        left: 380px;
        right: 38px;
        width: auto;
        float: none;
        bottom: 149px;
        top: 153px;
        overflow-y: auto;
      }
      & > .repeatable {
        display: none;
      }
      .definitionObj.group {
        padding: 0;
      }
    }
  }

  .gjs-new-asset-manager {
    .gjs-searcher-input {
      background-color: #ccc;
      color: #666;
    }

    i {
      color: #999;
      background-color: rgba(255,255,255,0.6);
    }

    .gjs-am-assets-footer {
      text-align: center;
    }

    button {
      background-color: #ccc;
      color: #666;

      &.selected,
      &:hover {
        background-color: hsla(0,0%,100%,.5) !important;
      }
    }

    .total {
      color: #666;
      padding-top: 5px;
    }

    .loading {
      text-align: center;

      img {
        position: relative;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/content/definitionLoader/index.vue